<template>
  <div class="layout-padding" :class="{'modalpage':page==='exhibition'}">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="상품 조회"
      desc="등록한 상품들의 현황을 조회할 수 있습니다."
      ref="admin_filter"
    ></admin-filter>

    <div class="columns is-multiline" style="margin-bottom:0">
      <div class="column is-6 flex" v-if="tableItems.length > 0 && page!=='exhibition'" style="margin:12px 0">
        <button class="button is-primary" style="margin-right:12px" @click="clickDelete">상품 일괄 삭제</button>
        <!--<button class="button" @click="$modal.show('adaptCategoryModal')" style="width:132px;margin-right:12px">카테고리 일괄 적용</button>-->
        <button class="button" @click="showCopyProductModal" style="width:132px">선택 상품 복사</button>
      </div>

      <div v-if="page !== 'exhibition'" class="column btn-group-justify-end" :class="{'is-6': tableItems.length > 0}">
        <button @click="$router.push('product/create')" class="button is-primary">상품 등록</button>
      </div>

      <div class="column is-full btn-group-justify-end" v-else-if="page==='exhibition'">
        <button class="button is-primary" @click="clickRegShowcase">선택 상품 등록</button>
      </div>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1808"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>
      <div slot="category" slot-scope="props" style="white-space: pre-wrap">{{ props.item.category.replaceAll('>','\n > ') }}</div>

      <div slot="first_img" slot-scope="props">
        <div style="display: inline-block; text-align: center"
             :style="thumbImgField(props.item.first_img)" v-if="props.item.first_img"></div>
      </div>

      <div slot="name" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="detailLink(props.item.id)">{{ props.item.name }}</span>
      </div>

      <div slot="is_simple" slot-scope="props">
        <div v-if="props.item.is_simple">간편상품</div>
        <div v-else>일반상품</div>
      </div>

      <div slot="price" slot-scope="props">
        <div>{{ props.item.price.price | currency }}</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickProd(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickProd(props.item,'delete')">삭제</button>
      </div>
    </admin-table>
    <!-- 상품 일괄 삭제 -->
    <modal name="deleteProductsModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="삭제" :useTab="false">
          <div>선택하신 {{ getIdList().length }}개의 상품을 삭제하시겠습니까?</div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('deleteProductsModal')">취소</button>
            <button class="button is-primary" @click="deleteProducts">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>

    <!-- 선택 상품 복사 -->
    <modal name="copyProductModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상품 복사" :useTab="false">
          <div>선택하신 {{ getIdList().length }}개의 상품을 복사하시겠습니까?</div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('copyProductModal')">취소</button>
            <button class="button is-primary" @click="copyProduct">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>

    <!-- 카테고리 일괄 적용 -->
    <modal name="adaptCategoryModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="카테고리 일괄 적용"
                        :useTab="false"
                        subtitle="*선택한 카테고리에 따른 세부설정은 상품 상세에서 설정을 하셔야 합니다.
                        ex) 선택한 카테고리의 상품종류가 아웃링크일 경우, 링크 설정은 상세에서 직접해야합니다.">
          <div class="columns is-multiline">
            <div class="column is-full" style="height: 300px">
              <lp-adm-drop-input ref="adminput_prod"
                                 :data.sync="catArr1"
                                 :selectVal="selectedCategory(prod.category1_id, 'cat1')"
                                 @onSelect="res => clickCategory(res.value, 'cat1')"
                                 placeholder="1차 카테고리"
                                 width="160px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

              <lp-adm-drop-input ref="adminput_prod"
                                 :data.sync="cat2"
                                 :selectVal="selectedCategory(prod.category2_id, 'cat2')"
                                 @onSelect="res => clickCategory(res.value, 'cat2')"
                                 placeholder="2차 카테고리"
                                 width="160px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

              <lp-adm-drop-input ref="adminput_prod"
                                 :data.sync="cat3"
                                 :selectVal="selectedCategory(prod.category3_id, 'cat3')"
                                 @onSelect="res => clickCategory(res.value, 'cat3')"
                                 placeholder="3차 카테고리"
                                 width="160px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

            </div>
          </div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('adaptCategoryModal')">취소</button>
            <button class="button is-primary" @click="adaptCategory">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>
  </div>
</template>

<script>
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpCheckBool from '../../module/common/LpCheckBool'
  import LpModal from '../../module/common/LpModal.vue'
  import AdminFilter from "../../module/admin/AdminFilter";
  import AdminTable from "../../module/admin/AdminTable";
  import ListMixin from '@/mixins/ListMixin'
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import InputFile from "../../module/common/InputFile";
  import OldInputFile from "../../module/common/OldInputFile";
  import ProductInfoExcelUpload from "../product/component/ProductInfoExcelUpload";
  import ProductMultipleImageUpload from "../product/component/ProductMultipleImageUpload";

  export default {
    name: 'ProductList',
    layout:'Main',
    mixins: [
      ListMixin
    ],
    props: {
      page: {
        type: String
      },
      selectedItems: {
        type: Array,
        default: function () {
          return []
        }
      },
      pack: {
        type: String
      },
      partnerProd: {
        type: Object
      },
      coupon: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ProductMultipleImageUpload,
      ProductInfoExcelUpload,
      OldInputFile,
      InputFile,
      LpAdmDropInput,
      AdminTable,
      AdminFilter, LpSortDropDown,
      LpInputText, LpRadio, LpModal,
      LpCheckBool
    },
    data () {
      return {
        modalProd: 0,
        prodStatus: [
          { label: '전체', value: 'all' },
          { label: '노출', value: 'visible' },
          { label: '비노출', value: 'invisible' },
        ],
        showcaseCheckArr: [
         /* { id: 1235, value: false },
          { id: 57, value: false },
          { id: 4, value: false },
          { id: 13, value: false }*/
        ],
        prod: {
          category1_id:'',
          category2_id:'',
          category3_id:''
        },
        catArr1: [],
        cat2: [],         //1차 카테고리 관련된 카테고리만
        cat3: [],         //2차 카테고리 관련된 카테고리만
        catArr2: [],
        catArr3: []
      }
    },
    created() {
      this.init();
    },
    watch: {
      'prod.category1_id'(n){
        this.cat2 = this.get_cat(this.catArr2, n);
      },
      'prod.category2_id'(n){
        this.cat3 = this.get_cat(this.catArr3, n)
      }
    },
    methods: {
      init () {
        let url = 'space/product';
        if(this.partnerProd) {
          url += `?partner_id=${this.partnerProd.id}`;
        }
        if(this.$route.query.search_keyword) {
          url += url.indexOf('?') >-1 ? '&' : '?';
          url += `search_keyword=${this.$route.query.search_keyword}`;
        }
        this.initializing('space_product', url);

        this.filtered.is_partner = false;

        this.getCats();
        if(this.tableData[0].eng_name !== 'checkspot') {
          this.tableData.splice(0, 0, this.tableValue('checkspot', '', 47));
        }
        /*if(this.page === 'exhibition') {
          if(this.tableData[0].eng_name !== 'checkspot') {
            this.tableData.splice(0, 0, this.tableValue('checkspot', '', 47));
          }
        }*/
        if(this.$route.query.partner) {
          this.filtered.search_type = 'partner';
          this.filtered.search_keyword = this.$route.query.partner;
          this.$nextTick(()=>{
            this.$refs.admin_filter.searchItem.search_keyword = this.$route.query.partner;
          });
        }
      },
      getDataFromServer() {
        this.getData();
      },
      // 체크박스 선택 관련 - 일괄 선택시 선택한 id list를 조합함
      getIdList(){
        return this.showcaseCheckArr.filter(i => i.value).map(i => i.id);
      },
      showCopyProductModal() {
        if(this.getIdList().length===0) {
          this.toast('상품을 선택해 주세요.');
        }
        else this.$modal.show('copyProductModal')
      },
      copyProduct () {
        let products = this.getIdList();
        if(products.length>0) {
          this.$store.commit('setLoading', true);
          this.$axios.post(this.getUrl('space/product/copy'), {
            checked: products
          }).then(res => {
            if(res.status===200) {
              this.$store.commit('setLoading', false);
              this.$modal.hide('copyProductModal');
              this.toast('복사가 완료되었습니다.')
              this.getData();
            }
          }).catch(error=>{
            this.$store.commit('setLoading', false);
            this.$modal.hide('copyProductModal');
            if (error.response) {
              this.toast(error.response.data.message);
            }
            else {
              this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
            }
          });
        }
      },
      // 상품 일괄 삭제
      clickDelete() {
        let id_list = this.getIdList();
        if(id_list.length===0) {
          this.toast('삭제할 상품을 선택해주세요.');
          return;
        }
        this.$modal.show('deleteProductsModal')
      },
      deleteProductAll() {
        this.$axios.delete(this.getUrl('product/delete/hard')).then(res=>{
          if(res.status===200) {
            this.toast('전체 상품이 삭제되었습니다.');
            this.$modal.hide('deleteProductAllModal');
            this.getData();
          }
        })
      },
      deleteProducts() {
        let id_list = this.getIdList();
        if(id_list.length===0) {
          this.toast('삭제할 상품을 선택해주세요.');
          return;
        }
        this.$axios.delete(this.getUrl('space/product/delete/multiple'), {
          data: {
            products: id_list
          }
        }).then(res=>{
          if(res.status===200) {
            this.toast('선택한 상품들이 삭제되었습니다.');
            this.$modal.hide('deleteProductsModal');
            this.getData();
          }
        })
      },
      // 카테고리 일괄 적용
      adaptCategory() {
        let id_list = this.getIdList();
        if(id_list.length===0) {
          this.toast('카테고리 일괄 적용할 상품을 선택해주세요.');
          return;
        }
        if(this.prod.category1_id==='') {
          this.toast('카테고리를 선택해주세요.');
          return;
        }
        let prod = this.cloneItem(this.prod);
        this.$axios.patch(this.getUrl('space/product/category/adapt/multiple'), {
          products: id_list,
          prod: prod
        }).then(res=>{
          if(res.status===200) {
            this.toast('카테고리 일괄 적용이 완료되었습니다.');
            this.$modal.hide('adaptCategoryModal');
            this.getData();
            this.prod = {
              category1_id:'',
              category2_id:'',
              category3_id:'',
              order_conversion_type: ''
            };
            this.selectedPack = 0;
          }
        })
      },
      isKey(eng_name) {
        return this.tableData.findIndex(i => i.eng_name === eng_name) > -1;
      },
      tableValue(eng, kor, width) {
        return {eng_name: eng, ko_name: kor, width: `${width}px`};
      },
      detailLink(id) {
        let path = `space/product/create?id=${id}`;
        this.$router.push(this.getPath(path));
      },
      clickProd(item, kind) {
        if(kind === 'update') {
          let path = 'space/product/create?id='+item.id;
          this.$router.push(this.getPath(path));
        } else if(kind === 'delete') {
          let value = {
            id: item.id,
            url: 'space/product/',
            title: '상품을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      delProduct() {
        this.$axios.delete(this.getUrl('space/product/')+this.modalProd)
          .then(res => {
            if (res.status===200) {
              this.$refs.deleteModal.close();
              this.toast('상품이 삭제되었습니다.');
              this.getData();
            }
          });
      },
      getProduct() {
        this.$axios.get(this.getUrl('space/product'), {
          params: this.filtered
        })
          .then(res => {
            if (res.status === 200) {
              this.showcaseCheckArr = res.data.data.map(i => {
                return {
                  id: i.id,
                  value: false
                }
              });
              // 기획전, 게시물에서 모달로 상품을 띄울 경우 선택된 상품이 있으면 체크 표시
              if(this.selectedItems && this.selectedItems.length>0) {
                this.showcaseCheckArr.forEach(item=>{
                  if(this.selectedItems.includes(item.id)){
                    item.value = true;
                  }
                })
              }
            }
          });
      },
      // 상품문의 & 상품후기 상품 등록
      clickReg(item) {
        let id = item.id;
        this.$emit('getProduct', id);
      },
      // 기획전 상품 등록
      clickRegShowcase() {
        let id_list = this.getIdList();
        let productItems = this.tableItems.filter(i => id_list.indexOf(i.id)>-1);
        this.$emit('productItems', {
          productItems: productItems,
          id_list: id_list
        });
      },
      getCats(){
        // 카테고리 가져오기
        this.$axios.get(this.getUrl('space/category'))
          .then(res => {
            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let cat of res.data) {
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name, packages: cat.packages});

              for (let cat2 of cat.child) {
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let cat3 of cat2.child) {
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
            this.cat2 = this.get_cat(this.catArr2, this.prod.category1_id);
            this.cat3 = this.get_cat(this.catArr3, this.prod.category2_id);
          });
      },
      selectedCategory(cat_id, type) {
        if(type === 'cat1') {
          type = 'catArr1';
        }
        let result = this[type].find(i => i.value === cat_id);
        return result ? result.label : undefined;
      },
      clickCategory(value, type) {
        if (type === 'cat1') {
          this.prod.category1_id = value;
          this.prod.category2_id = '';
          this.prod.category3_id = '';
        }
        else if (type === 'cat2') {
          this.prod.category2_id = value;
          this.prod.category3_id = '';
        }
        else if (type === 'cat3') {
          this.prod.category3_id = value;
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .modalpage
    margin-top 50px
    padding: 1.25rem

</style>
<style lang="stylus">
  .box-upper
    padding 18px
    border-bottom 1px solid #eeeeee

    .tab-wrapper
      display flex
      align-items center
      gap 8px

      .tab-item
        border-radius 50px
        padding 6px 14px
        border 1px solid #dddddd
        background-color white
        color #363636
        text-align center
        font-size 14px
        line-height 22px
      .selected
        background-color #363636
        border 1px solid #363636
        color white
</style>
